<form [formGroup]="jaarruimtes">
    <div *ngIf="jaarruimteGegevens.length > 0" class="row">
        <div formArrayName="jaarruimteGegevens">

            <div *ngFor="let item of jaarruimteGegevens.controls; let i = index;"
                 [formGroupName]="i">
                <div *ngIf="i === 0" class="row">
                    <snelstart-ui-select-form-control
                            (change)="saveForm()"
                            [class]="'custom-input-125'"
                            [label]="i === 0  ? 'Jaar' : ''"
                            [options]="jaarRuimteJaar"
                            [required]=true
                            formControlName="jaar"
                            id="jaarJR"
                    >
                    </snelstart-ui-select-form-control>

                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i === 0 ? 'custom-input-125' : 'custom-input-125'"
                            [decimals]="0"
                            [label]="i < 2 ? 'Winst': ''"
                            align="right"
                            formControlName="winstUitOnderneming"
                            id="winstUitOndernemingJr"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i ===0 ? 'custom-input-125' : 'custom-input-125'"
                            [decimals]="0"
                            [disabledControl]="true"
                            [label]="i < 2  ? '+/+ FOR' : ''"
                            align="right"
                            formControlName="toevoegingFor"
                            id="toevoegingForJr"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i === 0 ? 'custom-input-125' : 'custom-input-125'"
                            [decimals]="0"
                            [label]="i < 2  ? '-/- FOR' : ''"
                            align="right"
                            formControlName="afnemingFor"
                            id="afnemingForJr"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i === 0 ? 'custom-input-125' : 'custom-input-125'"
                            [decimals]="0"
                            [label]="i < 2 ? 'Loon/Uitk.' : ''"
                            align="right"
                            formControlName="belastbaarLoon"
                            id="belastbaarLoonJr"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i === 0 ? 'custom-input-125' : 'custom-input-125'"
                            [decimals]="0"
                            [label]="i < 2  ? 'Factor A' : ''"
                            align="right"
                            formControlName="factorA"
                            id="factorAJr"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i === 0 ? 'custom-input-125' : 'custom-input-125'"
                            [decimals]="0"
                            [label]="i < 2  ? 'Row/Tbs' : ''"
                            align="right"
                            formControlName="belastbaarROW"
                            id="belastbaarROWJr"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i === 0 ? 'custom-input-125' : 'custom-input-125'"
                            [decimals]="0"
                            [label]="i < 2  ? 'Per. uitkeringen' : ''"
                            align="right"
                            formControlName="belastbarePU"
                            id="belastbarePUJr"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i === 0 ? 'custom-input-125' : 'custom-input-125'"
                            [decimals]="0"
                            [label]="i < 2  ? 'Netto pensioen' : ''"
                            align="right"
                            formControlName="premiesNettoPensioen"
                            id="premiesNettoPensioenJr"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <!--                    <snelstart-ui-number-form-control-->
                    <!--                            formControlName="afgetrokkenPremie"-->
                    <!--                            id="afgetrokkenPremieJr"-->
                    <!--                            [label]="i < 2  ? 'Benutte ruimte' : ''"-->
                    <!--                            [class]="i === 0 ? 'col-auto custom-input-100' : 'col-auto custom-input-100'"-->
                    <!--                            [decimals]="0"-->
                    <!--                            align="right"-->
                    <!--                            prefix="€"-->
                    <!--                            (change)="saveForm()"-->
                    <!--                    >-->
                    <!--                    </snelstart-ui-number-form-control>-->
                    <snelstart-ui-button
                            (click)="verwijderRijJaarruimteGegevens(i)"
                            [class]="i === 0 ? 'pt-3 custom-input-75' : i === 1 ? 'custom-input-75' : 'custom-input-75' "
                            class="delete"
                            icon="trash"
                            iconType="light"
                            id="buttonDeleteJaarruimteGegevensJr"
                            size="medium"
                            type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
            </div>

            <div class="pt-1 pb-2">
                Let op! De gegevens voor de <u>jaarruimte</u> {{ this.jaar }} zijn de bedragen uit het jaar {{ this.jaar - 1 }}.
            </div>
        </div>
    </div>
</form>

<form [formGroup]="jaarruimtes">
    <div *ngIf="jaarruimteGegevens.length > 1" class="row">
        <div formArrayName="jaarruimteGegevens">
            <div *ngFor="let item of jaarruimteGegevens.controls; let i = index;"
                 [formGroupName]="i">
                <div *ngIf="i > 0" class="row">
                    <snelstart-ui-select-form-control
                            (change)="saveForm()"
                            [class]="i === 1 ? 'pt-3 custom-input-125' : 'custom-input-125'"
                            [label]="i === 1 ? 'Jaar' : ''"
                            [options]="reserveringsRuimtenJaren"
                            [required]="true"
                            formControlName="jaar"
                            id="jaarRR"
                    >
                    </snelstart-ui-select-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i === 1 ? 'pt-3 custom-input-125' : 'custom-input-125'"
                            [decimals]="0"
                            [label]="i < 2 ? 'Winst' : ''"
                            align="right"
                            formControlName="winstUitOnderneming"
                            id="winstUitOnderneming"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i === 1 ? 'pt-3 custom-input-100' : 'custom-input-100'"
                            [decimals]="0"
                            [disabledControl]="jaarruimteGegevens.controls[i].get('jaar')?.value >= 2024"
                            [label]="i < 2  ? '+/+ FOR' : ''"
                            align="right"
                            formControlName="toevoegingFor"
                            id="toevoegingFor"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i === 1 ? 'pt-3 custom-input-100' : 'custom-input-100'"
                            [decimals]="0"
                            [label]="i < 2  ? '-/- FOR' : ''"
                            align="right"
                            formControlName="afnemingFor"
                            id="afnemingFor"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i === 1 ? 'pt-3 custom-input-125' : 'custom-input-125'"
                            [decimals]="0"
                            [label]="i < 2 ? 'Loon/Uitker.' : ''"
                            align="right"
                            formControlName="belastbaarLoon"
                            id="belastbaarLoon"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i === 1 ? 'pt-3 custom-input-100' : 'custom-input-100'"
                            [decimals]="0"
                            [label]="i < 2  ? 'Factor A' : ''"
                            align="right"
                            formControlName="factorA"
                            id="factorA"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i === 1 ? 'pt-3 custom-input-125' : 'custom-input-125'"
                            [decimals]="0"
                            [label]="i < 2  ? 'Row/Tbs' : ''"
                            align="right"
                            formControlName="belastbaarROW"
                            id="belastbaarROW"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i === 1 ? 'pt-3 custom-input-125' : 'custom-input-125'"
                            [decimals]="0"
                            [label]="i < 2  ? 'Per. uitkeringen' : ''"
                            align="right"
                            formControlName="belastbarePU"
                            id="belastbarePU"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i === 1 ? 'pt-3 custom-input-125' : 'custom-input-125'"
                            [decimals]="0"
                            [label]="i < 2  ? 'Netto pensioen' : ''"
                            align="right"
                            formControlName="premiesNettoPensioen"
                            id="premiesNettoPensioen"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control
                            (change)="saveForm()"
                            [class]="i === 1 ? 'pt-3 custom-input-100' : 'custom-input-100'"
                            [decimals]="0"
                            [label]="i < 2  ? 'Benut' : ''"
                            align="right"
                            formControlName="afgetrokkenPremie"
                            id="afgetrokkenPremie"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-button
                            (click)="verwijderRijJaarruimteGegevens(i)"
                            [class]="i === 0 ? 'pt-3 custom-input-50' : i === 1 ? 'pt-6 custom-input-50' : ' custom-input-50' "
                            class="delete"
                            icon="trash"
                            iconType="light"
                            id="buttonDeleteJaarruimteGegevens"
                            size="medium"
                            type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
            </div>
        </div>
    </div>
</form>
<div *ngIf="jaarruimteGegevens.length === 0">
    <snelstart-ui-button (click)="addRijJaarruimteGegevens()" class="snelstart-ui-button" icon="plus"
                         type="link">Jaarruimte invullen
    </snelstart-ui-button>
</div>
<div *ngIf="jaarruimteGegevens.length === 1">
    <snelstart-ui-button (click)="addRijJaarruimteGegevens()" class="snelstart-ui-button" icon="plus"
                         type="link">Reserveringsruimte {{ jaar - 10 }} - {{ jaar - 1 }}
        invullen
    </snelstart-ui-button>
</div>
<div *ngIf="jaarruimteGegevens.length > 1">
    <snelstart-ui-button (click)="addRijJaarruimteGegevens()" class="snelstart-ui-button" icon="plus"
                         type="link">Reserveringsruimte toevoegen
    </snelstart-ui-button>
</div>

<div *ngIf="jaarruimteGegevens.length > 1">
    <div class="pt-1 pb-2">
    Let op! De gegevens voor de <u>reserveringruimte</u> van een jaar  zijn de bedragen uit het voorgaande jaar.<br/>
    Voorbeeld: reserveringsruimte {{this.jaar -1}}? Vul de bedragen in uit het jaar {{this.jaar -2}}.
    </div>
</div>


